import { Http } from "@/util";

export function listReceipt(param) {
  return Http.post("/admin/invoice/list", param);
}

export function listDetails(invoiceId) {
  return Http.get("/admin/invoice/order/detail/list", { invoiceId });
}

export function addReceipt(param) {
  return Http.post("/admin/invoice/add", param);
}

export function modifyReceipt(param) {
  return Http.post("/admin/invoice/update", param);
}

export function uploadInvoice(param) {
  return Http.post("/admin/invoice/upload/invoice", param);
}

export function modifyInvoiceOrder(param) {
  return Http.post("/admin/invoice/order/modify", param);
}

export function delInvoiceOrder(param) {
  return Http.post("/admin/invoice/order/del", param);
}

/** 税务电票登录状态 */
export function getEleLoginStatus() {
  return Http.get("/admin/invoice/ele/login/status", { _hideLoading: true });
}

/** 可选税务登录账号 */
export function getEleLoginAccounts() {
  return Http.get("/admin/invoice/ele/login/accounts");
}

/** 清除税务登录会话 */
export function logoutEleLogin() {
  return Http.post("/admin/invoice/ele/login/logout", {});
}

/** 发起税务登录（触发短信） */
export function startEleLogin(username) {
  return Http.post("/admin/invoice/ele/login/start", { username });
}

/** 提交税务登录短信验证码 */
export function submitEleLoginSms(smsCode) {
  return Http.post("/admin/invoice/ele/login/sms", { smsCode });
}

/** 查询开票结果；part: TRANSPORT | LIFE | DEFAULT */
export function queryEleInvoiceResult(orderId, part) {
  const param = { orderId };
  if (part) {
    param.part = part;
  }
  return Http.get("/admin/invoice/ele/query/result", param);
}

/** 批量开票 */
export function batchIssueInvoice(ids) {
  return Http.post("/admin/invoice/ele/batch/issue", ids);
}

/** 重新开票并发送邮件给乘客 */
export function reIssueAndSendInvoice(invoiceId) {
  return Http.post("/admin/invoice/ele/reissue/send?invoiceId=" + invoiceId, {});
}

/** 获取二次认证二维码 */
export function getEleQrCode(param = {}) {
  return Http.post("/admin/invoice/ele/qrcode", param);
}

/** 查询二次认证状态 */
export function queryEleQrCodeStatus(rzid, type) {
  return Http.get("/admin/invoice/ele/qrcode/status", { rzid, type, _hideLoading: true });
}

/** 重新开票；part: TRANSPORT | LIFE | DEFAULT */
export function reIssueEleInvoice(orderId, part) {
  let url = "/admin/invoice/ele/reissue?orderId=" + orderId;
  if (part) {
    url += "&part=" + encodeURIComponent(part);
  }
  return Http.post(url, {});
}

/** 简易红冲；part: TRANSPORT | LIFE | DEFAULT */
export function redIssueEleInvoice(orderId, part) {
  let url = "/admin/invoice/ele/red?orderId=" + orderId;
  if (part) {
    url += "&part=" + encodeURIComponent(part);
  }
  return Http.post(url, {});
}
